import { render } from "./UserLayout.vue?vue&type=template&id=53d92138&ts=true"
import script from "./UserLayout.vue?vue&type=script&lang=ts"
export * from "./UserLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__